import { FC } from "react";

import { AvailablePaymentCurrency, formatCurrencyFromCents } from "@simplyk/common";

import { useLocaleContext } from "@/common/contexts/LocaleContext";
import { useTranslate } from "@/common/hooks/useTranslate";
import { FormTypography } from "@/forms-design-system/FormTypography";

interface PrizeValueProps {
  value: number;
  currency: AvailablePaymentCurrency;
}

export const PrizeValue: FC<PrizeValueProps> = ({ value, currency }) => {
  const { t } = useTranslate();
  const { isoLocale } = useLocaleContext();

  return (
    <FormTypography variant="subtitle2" vibe="brand" sx={{ whiteSpace: "nowrap" }}>
      {t("ticketing", "prizes.value", { amount: formatCurrencyFromCents(value, { isoLocale, currency }) })}
    </FormTypography>
  );
};
